import React from "react";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  FormControlLabel,
  Grid,
  Stack,
  Switch,
} from "@mui/material";
import { TimePicker } from "@mui/x-date-pickers";
import { Dayjs } from "dayjs";

export const DAYS = [
  "Montag",
  "Dienstag",
  "Mittwoch",
  "Donnerstag",
  "Freitag",
  "Samstag",
  "Sonntag",
];

export interface DailySchedule {
  day: string;
  open: Dayjs;
  close: Dayjs;
  closed: boolean;
}

interface ScheduleGridProps {
  weekly: DailySchedule[];
  onWeeklyChange: (
    index: number,
    field: keyof Omit<DailySchedule, "day">,
    value: any,
  ) => void;
  switchLabel: string;
}

export function ScheduleGrid({
  weekly,
  onWeeklyChange,
  switchLabel,
}: ScheduleGridProps) {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container spacing={{ xs: 2 }} columns={{ xs: 1, sm: 2, md: 3 }}>
        {weekly.map((row, i) => (
          <Grid key={i} size={{ xs: 1, sm: 1, md: 1 }}>
            <Card variant="outlined">
              <CardHeader
                title={row.day}
                action={
                  <FormControlLabel
                    control={
                      <Switch
                        checked={!row.closed}
                        onChange={(e) =>
                          onWeeklyChange(i, "closed", !e.target.checked)
                        }
                      />
                    }
                    label={switchLabel}
                  />
                }
              />
              <CardContent>
                <Stack spacing={2}>
                  <TimePicker
                    label="Von"
                    ampm={false}
                    disabled={row.closed}
                    value={row.open}
                    onChange={(v) => v && onWeeklyChange(i, "open", v)}
                  />
                  <TimePicker
                    label="Bis"
                    ampm={false}
                    disabled={row.closed}
                    value={row.close}
                    onChange={(v) => v && onWeeklyChange(i, "close", v)}
                  />
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
